import {FACTIONS} from "../../../constants/factions";

export const LEPRECHAUNS_QUOTES = [{
  quote: 'Ты копишь золото. Я его трачу. Но почему-то именно твоё хранилище становится пустым',
  author: 'Делан О’Брин, лепрекон-мастер сокрытых краж',
  factionId: FACTIONS.LEPRECHAUNS
}, {
  quote: 'Лучшая налоговая политика — чужая налоговая политика, но с нашим ключом',
  author: 'Квинт Випсаний, лепрекон-знаток налогового права',
  factionId: FACTIONS.LEPRECHAUNS
}, {
  quote: 'Мы не воюем с казной. Мы сливаем её по капле. А когда она пуста — вы сами отдаёте нам города за бочку пива',
  author: 'Флорин Сребролом, лепрекон-взломщик императорской казны',
  factionId: FACTIONS.LEPRECHAUNS
}, {
  quote: 'Побеждает не тот, у кого больше золота, а тот, кто знает, где чужое спрятано. И умеет открывать чужие замки',
  author: 'Ошин Каллаган, лепрекон-хранитель Черной казны',
  factionId: FACTIONS.LEPRECHAUNS
}, {
  quote: 'Устрой все так, чтобы враг догадался, что работает на тебя, только когда будет уже поздно',
  author: 'Флорин Щипач, лепрекон-карманник Марсова поля',
  factionId: FACTIONS.LEPRECHAUNS
}, {
  quote: 'Ты будешь должен всегда, сколько бы не отдал',
  author: 'неизвестный лепрекон-философ',
  factionId: FACTIONS.LEPRECHAUNS
}]